import React from 'react';
import ReactPaginate from 'react-paginate';
import cn from 'classnames';
import styles from './pagination.module.scss';

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  serverAppTheme,
}) => {
  if (!totalPages || totalPages <= 0) return null;
  const showArrows = totalPages > 1;

  const handlePageClick = ({ selected }) => {
    onPageChange(selected + 1);
  };

  const navStyle = {
    color: serverAppTheme?.pagination_btn_text,
    backgroundColor: serverAppTheme?.pagination_btn_colour,
  };

  return (
    <div
      className={cn(styles.wrapper, 'fs_16')}
      style={{
        '--pagination-border': serverAppTheme?.pagination_border,
        '--number-bg': serverAppTheme?.tip_tile,
        '--number-text': serverAppTheme?.primary_text,
        '--active-bg': serverAppTheme?.Category_text,
        '--active-text': serverAppTheme?.seat_box_text,
        color: serverAppTheme?.pagination_btn_text,
      }}
    >
      {showArrows && (
        <>
          <button
            className={cn(styles.navBtn, styles.navBtnLg, { [styles.navDisabled]: currentPage === 1 })}
            onClick={() => currentPage > 1 && onPageChange(1)}
            disabled={currentPage === 1}
            style={navStyle}
          >
            {'<<'}
          </button>
          <button
            className={cn(styles.navBtn, styles.navMargin, styles.navBtnLg, { [styles.navDisabled]: currentPage === 1 })}
            onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
            style={navStyle}
          >
            {'<'}
          </button>
        </>
      )}
      <ReactPaginate
        breakLabel="..."
        nextLabel={null}
        previousLabel={null}
        onPageChange={handlePageClick}
        forcePage={currentPage - 1}
        pageCount={totalPages}
        pageRangeDisplayed={5}
        marginPagesDisplayed={1}
        renderOnZeroPageCount={null}
        containerClassName={styles.pagination}
        pageClassName={styles.pageItem}
        pageLinkClassName={styles.pageLink}
        breakClassName={styles.pageItem}
        breakLinkClassName={styles.pageLink}
        activeClassName={styles.active}
        disabledClassName={styles.disabled}
      />
      {showArrows && (
        <>
          <button
            className={cn(styles.navBtn, styles.navMargin, styles.navBtnLg, { [styles.navDisabled]: currentPage === totalPages })}
            onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            style={navStyle}
          >
            {'>'}
          </button>
          <button
            className={cn(styles.navBtn, styles.navMargin, styles.navBtnLg, { [styles.navDisabled]: currentPage === totalPages })}
            onClick={() => currentPage < totalPages && onPageChange(totalPages)}
            disabled={currentPage === totalPages}
            style={navStyle}
          >
            {'>>'}
          </button>
        </>
      )}
    </div>
  );
};

export default React.memo(Pagination);
